// extracted by mini-css-extract-plugin
module.exports = {"onboard_modal_container":"OnboardItemModal_onboard_modal_container__1OtCr"};